<template>
  <span class="icon-trigger" @click.stop="toggle">
    <font-awesome-icon :id="title" class="fa-fw" icon="question-circle" />
    <Popover ref="overlay">
      <strong>{{ title }}</strong>
      <p style="max-width: 20rem">{{ description }}</p>
      <p v-if="link">
        <a :href="link" target="_blank">
          {{ $t('features.help_icon.go_to_support') }}
        </a>
      </p>
    </Popover>
  </span>
</template>

<script lang="ts">
import type Popover from 'primevue/popover';
export default {
  name: 'HelpIcon',
  props: {
    title: { required: false },
    description: { type: String, required: false },
    link: { type: String, required: false },
  },
  methods: {
    toggle(event) {
      (this.$refs.overlay as InstanceType<typeof Popover>).toggle(event);
    },
  },
};
</script>
